export const   fetching= 'FETCHING_NEIGHBORHOODS'
export const   fetched= 'FETCHED_NEIGHBORHOODS'
export const   error= 'ERROR_FETCHING_NEIGHBORHOODS'
